import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AportacionDiAdheridoControllerService, AportacionDICargaMasivaAdheridoPayloadDTO  } from 'api-rest';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';

@Component({
  selector: 'lib-attached-contributions-dis-upload-dialog',
  templateUrl: './attached-contributions-dis-upload-dialog.component.html',
  styleUrls: ['./attached-contributions-dis-upload-dialog.component.scss']
})
export class AttachedContributionsDisUploadDialogComponent {
  formGroup!: FormGroup;
  tiposDocumento: any[] = [];
  adjuntosBlob: Array<any> = [];
  botonEstado: boolean = false;
  flagTooltip: boolean = false;

  adherido: any;
  gestorResiduo: any;
  isAdherido: boolean = false;
  isGestor: boolean = false;
  codigoDocumentoAdheridoArray: any[] = [];
  nimaGestorArray: any[] = [];

  documento: File | undefined;
  isDragging = false;
  files: File[] = [];

  grid: any[] = [];
  headArray: any[] = [
    {
      Head: 'Documento',
      FieldName: 'name',
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Borrar',
          show: { params: 'canAccessDelete', accion: 'delete' },
        },
      ],
      width: '2',
      permanent: true,
    },
  ];

  constructor(
    @Inject('environment') private environment: any,
    public dialogRef: MatDialogRef<AttachedContributionsDisUploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private aportacionAdheridoCtrSrv: AportacionDiAdheridoControllerService
  ) {
    this.adherido = this.data?.adherido;
    // this.gestorResiduo = this.data?.adherido.gestorResiduo;


    this.inicializarForm();
  }

  ngOnInit(): void {
    if (this.adherido) {
      this.codigoDocumentoAdheridoArray = [this.adherido];
    }
    if (this.gestorResiduo) {
      this.nimaGestorArray = [this.gestorResiduo];
    }
  }

  inicializarForm() {
    this.formGroup = this.formBuilder.group({
      adherido: [
        { value: `${this.adherido?.codigoDocumento} - ${this.adherido?.razonSocial}`, disabled: true },
      ],
      nimaGestor: [
        { value: `${this.gestorResiduo?.nima} - ${this.gestorResiduo?.razonSocial}`, disabled: true },
      ],
      esAportacionSDDRCA: [
        { value: false, disabled: false },
      ],
    });
  }

  closeDialog(): void {
    this.dialogRef.close(null);
  }

  attachAdjunto(archivos: any): void {
    if (archivos != null && archivos != undefined && archivos.length > 0) {
      this.addFiles(archivos);
    }
  }

  // //addFile(){
  // //  if(this.documento){
  // //    //Comporbar que no exista un fichero con el mismo nombre
  // //    if(this.adjuntosBlob.filter((item) => item.name == this.documento?.name).length > 0){
  // //      this.snackBarSrv.showSnackBar(
  // //        'Ya se ha añadido un documento con el mismo nombre.',
  // //        'error'
  // //      );
  // //    }else{
  // //      this.grid = [];
  // //      this.adjuntosBlob.push(this.documento);
  // //      this.grid = this.adjuntosBlob.map(item => ({ name: item.name, canAccessDelete: true }));
  // //      this.documento = undefined;
  // //    }
  // //    
  // //  }
  // //}

  action(event: any) {
    if (event.nameButton == 'delete') {
      this.deleteFile(event);
    }
  }

  canAccessDelete(): boolean {
    return true;
  }

  deleteFile(element: any) {
    this.adjuntosBlob = this.adjuntosBlob.filter((item: any) => item.name !== element.name);
    this.grid = this.adjuntosBlob.map(item => ({ name: item.name, canAccessDelete: true }));
    this.files = [...this.adjuntosBlob];
  }

  saveData() {
    if (this.adjuntosBlob == null || this.adjuntosBlob == undefined || this.adjuntosBlob.length == 0) {
      this.snackBarSrv.showSnackBar('Adjunte documento', 'error');
      return;
    }
    this.spinnerSrv.loadingShow();
    let cargaAportPayload: AportacionDICargaMasivaAdheridoPayloadDTO  = {
      adherido: this.adherido,
      gestorResiduos: this.gestorResiduo,
      esMultipleDI: this.data?.esMultipleDI
    };

    this.aportacionAdheridoCtrSrv.cargaMasiva(cargaAportPayload, this.adjuntosBlob).subscribe({
      next: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Las aportaciones se han registrado correctamente y comenzarán a cargarse en el buscador de forma progresiva, ya que el proceso de lectura puede tardar unos minutos. Si necesitamos que realice alguna acción adicional, nos pondremos en contacto con usted por correo electrónico.', 'success');
        this.dialogRef.close(true);
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Ha ocurrido un error al crear las aportaciones.', 'error');
      },
    });
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    if (event.dataTransfer && event.dataTransfer.files) {
      this.addFiles(event.dataTransfer.files);
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.addFiles(input.files);
    }
  }

  addFiles(fileList: FileList) {
    for (let i = 0; i < fileList.length; i++) {
      const pFile = fileList.item(i);
      if (this.isValidFile(pFile)) {
        if (this.adjuntosBlob.filter((item) => item.name == pFile?.name).length > 0) {
          this.snackBarSrv.showSnackBar(
            'Ya se ha añadido un documento con el mismo nombre.',
            'error'
          );
        } else {
          this.grid = [];
          this.adjuntosBlob.push(pFile);
          this.grid = this.adjuntosBlob.map(item => ({ name: item.name, canAccessDelete: true }));
          this.files = [...this.adjuntosBlob];
          this.documento = undefined;
        }
      }
    }
  }

  isValidFile(archivo: File | null) {
    let isValid = false;
    if (archivo != null) {
      const isPDF = archivo.type === 'application/pdf' && archivo.name.toLowerCase().endsWith('.pdf');
      if (!isPDF) {
        this.snackBarSrv.showSnackBar(
          'Solo se permiten archivos pdf',
          'error'
        );
      } else if (archivo.size === 0) {
        this.snackBarSrv.showSnackBar(
          'No se puede subir un fichero vacío',
          'error'
        );
      } else if (archivo.size > 12 * 1024 * 1024) {
        this.snackBarSrv.showSnackBar(
          'El fichero supera el tamaño máximo permitido de 12 MB',
          'error'
        );
      } else {
        isValid = true;
      }
    }

    return isValid;
  }

}
